import React, { useEffect, useState } from "react";
import { fetchPicture } from "@/components/UserAvatar";

export const EBOOK_COVER_FALLBACK = "https://images.unsplash.com/photo-1574884280706-7342ca3d4231?crop=entropy&cs=srgb&fm=jpg&q=85&w=400";

export default function EbookCover({ path, fallback, className, testId }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let cancelled = false;
    if (!path) { setUrl(null); return undefined; }
    fetchPicture(path).then((u) => { if (!cancelled) setUrl(u); });
    return () => { cancelled = true; };
  }, [path]);
  return <img src={url || (path ? undefined : fallback)} alt="" data-testid={testId} className={className}
              style={{ transition: "transform 0.4s ease", visibility: path && !url ? "hidden" : "visible" }} />;
}
